// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width: 991px) {\n  .result-ops-pagination-container {\n    text-align: center;\n  }\n}\n@media (min-width: 992px) {\n  .result-ops-pagination-container {\n    text-align: right;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
